// BELANGRIJJK: U kunt hieronder uw advertentie-HTML van Daisycon plakken.

const adHtmlJcPets = `
<div class="animate-solar-wind p-6 bg-card rounded-xl border text-center shadow-sm transition-shadow hover:shadow-md">
    <h3 class="font-bold text-lg text-primary my-1">Alles voor uw Hond (en Kat!)</h3>
    <p class="text-muted-foreground text-sm max-w-md mx-auto mb-4">Ontdek een groot aanbod van voeding, snacks, speelgoed en professionele verzorgingsproducten.</p>
    <a href="https://glp8.net/c/?si=20258&li=1865558&wi=417066&ws=" rel="sponsored nofollow" target="_blank" 
       class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
      Ontdek JcPets.com
    </a>
</div>
`;

const adHtmlBrekz = `
<div class="animate-solar-wind bg-card rounded-xl border text-center shadow-sm transition-shadow hover:shadow-md overflow-hidden">
    <a href="https://fr135.net/c/?si=20686&li=1880765&wi=417066&ws=" rel="sponsored nofollow" target="_blank">
        <img src="https://static-dscn.net/20686/1880765/?wi=417066&ws=" alt="Advertentie van Brekz.be" style="max-width:100%; height:auto; border:none;" />
    </a>
</div>
`;

const adHtmlZooplus = `
<div class="animate-solar-wind bg-card rounded-xl border text-center shadow-sm transition-shadow hover:shadow-md overflow-hidden">
    <a href="https://fr135.net/c/?si=14720&li=1774618&wi=417066&ws=" rel="sponsored nofollow" target="_blank">
        <img src="https://static-dscn.net/14720/1774618/?wi=417066&ws=" alt="Advertentie van Zooplus.be" style="max-width:100%; height:auto; border:none;" />
    </a>
</div>
`;

const adHtmlPharmapets = `
<div class="animate-solar-wind bg-card rounded-xl border text-center shadow-sm transition-shadow hover:shadow-md overflow-hidden">
    <a href="https://glp8.net/c/?si=20150&li=1867543&wi=417066&ws=" rel="sponsored nofollow" target="_blank">
        <img src="https://static-dscn.net/20150/1867543/?wi=417066&ws=" alt="Advertentie van Pharmapets" style="max-width:100%; height:auto; border:none;" />
    </a>
</div>
`;

const adHtmlElectricianPlaceholder1 = `
<div class="min-h-[120px] bg-card rounded-xl border border-dashed flex items-center justify-center p-6 text-center">
    <p class="text-xs text-muted-foreground italic">Advertentie ruimte gereserveerd (Daisycon Elektriciens)</p>
</div>
`;

const adHtmlElectricianPlaceholder2 = `
<div class="min-h-[120px] bg-card rounded-xl border border-dashed flex items-center justify-center p-6 text-center">
    <p class="text-xs text-muted-foreground italic">Advertentie ruimte gereserveerd (Daisycon Diensten)</p>
</div>
`;


// Array met alle beschikbare advertenties voor honden-gerelateerde pagina's.
const allDogAds = [adHtmlJcPets, adHtmlBrekz, adHtmlZooplus, adHtmlPharmapets];
const allElectricianAds = [adHtmlElectricianPlaceholder1, adHtmlElectricianPlaceholder2];

export const daisyconAds = {
  // Advertenties voor blog pagina's.
  blogBanners: allDogAds,
  
  // Advertenties voor salon lijsten.
  salonListAds: allDogAds,

  // Advertenties voor salon detail pagina's.
  salonDetailAds: allDogAds,

  // Advertenties voor elektricien lijsten.
  electricianListAds: allElectricianAds,

  // Advertenties voor elektricien detail pagina's.
  electricianDetailAds: allElectricianAds,
};
